var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "700 300 1300 1300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1205 1526 c-129 -37 -245 -110 -321 -203 -270 -332 -144 -816 254 -977 73 -29 84 -31 217 -31 121 0 149 3 207 23 300 104 477 430 398 736 -51 201 -202 369 -393 436 -80 29 -285 37 -362 16z m264 -131 c88 -21 156 -60 175 -100 63 -131 -62 -459 -254 -668 -98 -107 -185 -150 -254 -127 -49 16 -158 119 -195 183 -85 151 -82 355 8 496 114 177 320 263 520 216z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebex);
export default __webpack_public_path__ + "static/media/webex.dab5e3d1f9e2d2cd8ae2a208f59f91ed.svg";
export { ForwardRef as ReactComponent };